// This file is auto-generated by @buzola/vite-plugin. Do not edit.
/* eslint-disable */

import { lazy, type ComponentType } from 'react';
import { buildRouteTree } from '@buzola/router';
import type { RouteConfig } from '@buzola/router';

import Route0 from './routes/_layout';
const Route1 = () => import('./routes/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
import Route2 from './routes/login/_layout';
const Route3 = () => import('./routes/login/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route4 = () => import('./routes/login/password-reset').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route5 = () => import('./routes/login/reset-request-success').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route6 = () => import('./routes/login/reset-request').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route7 = () => import('./routes/api-keys').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route8 = () => import('./routes/cms/article-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route9 = () => import('./routes/cms/articles').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route10 = () => import('./routes/cms/banners').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route11 = () => import('./routes/cms/course-blocks-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route12 = () => import('./routes/cms/footer').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route13 = () => import('./routes/cms/navigation').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route14 = () => import('./routes/cms/page-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route15 = () => import('./routes/cms/pages').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route16 = () => import('./routes/cms/people').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route17 = () => import('./routes/cms/person-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route18 = () => import('./routes/cms/podcast-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route19 = () => import('./routes/cms/podcasts').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route20 = () => import('./routes/cms/redirects').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route21 = () => import('./routes/cms/site-settings').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route22 = () => import('./routes/cms/support-ctas').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route23 = () => import('./routes/cms/tags').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route24 = () => import('./routes/contact-form-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route25 = () => import('./routes/contact-form-submission-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route26 = () => import('./routes/contact-form-submissions').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route27 = () => import('./routes/contact-forms').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route28 = () => import('./routes/course-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route29 = () => import('./routes/course-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route30 = () => import('./routes/course-interests').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route31 = () => import('./routes/course-tags').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route32 = () => import('./routes/course-term-attendance').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route33 = () => import('./routes/course-term-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route34 = () => import('./routes/course-term-new').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route35 = () => import('./routes/course-terms').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route36 = () => import('./routes/courses').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route37 = () => import('./routes/dashboard').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route38 = () => import('./routes/discount-code-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route39 = () => import('./routes/discount-code-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route40 = () => import('./routes/discount-codes').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route41 = () => import('./routes/email-template-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route42 = () => import('./routes/email-texts').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route43 = () => import('./routes/emails').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route44 = () => import('./routes/gd/call-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route45 = () => import('./routes/gd/calls').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route46 = () => import('./routes/gd/checkout-probes').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route47 = () => import('./routes/gd/chrome').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route48 = () => import('./routes/gd/demo-user-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route49 = () => import('./routes/gd/demo-users').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route50 = () => import('./routes/gd/discount-code-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route51 = () => import('./routes/gd/discount-codes').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route52 = () => import('./routes/gd/email-template-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route53 = () => import('./routes/gd/email-texts').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route54 = () => import('./routes/gd/emails').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route55 = () => import('./routes/gd/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route56 = () => import('./routes/gd/issuer-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route57 = () => import('./routes/gd/issuers').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route58 = () => import('./routes/gd/order-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route59 = () => import('./routes/gd/orders').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route60 = () => import('./routes/gd/page-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route61 = () => import('./routes/gd/pages').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route62 = () => import('./routes/gd/plans').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route63 = () => import('./routes/gd/schvaleni').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route64 = () => import('./routes/gd/search').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route65 = () => import('./routes/gd/settings').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route66 = () => import('./routes/gd/subscriber-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route67 = () => import('./routes/gd/subscribers').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route68 = () => import('./routes/gd/taxonomies').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route69 = () => import('./routes/gd/testimonials').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route70 = () => import('./routes/gd/user-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route71 = () => import('./routes/gd/users').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route72 = () => import('./routes/members').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route73 = () => import('./routes/order-create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route74 = () => import('./routes/order-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route75 = () => import('./routes/orders').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route76 = () => import('./routes/organization-detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route77 = () => import('./routes/organizations').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route78 = () => import('./routes/search').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;

// Module augmentation for type-safe page-centric routing
declare module '@buzola/router' {
  interface BuzolaPageMap {
    'index': {};
    'login': {};
    'login/password-reset': {};
    'login/reset-request-success': {};
    'login/reset-request': {};
    'api-keys': {};
    'cms/article-edit': { id?: string };
    'cms/articles': {};
    'cms/banners': {};
    'cms/course-blocks-edit': { id: string };
    'cms/footer': {};
    'cms/navigation': {};
    'cms/page-edit': { id?: string };
    'cms/pages': {};
    'cms/people': {};
    'cms/person-edit': { id?: string; returnCourseId?: string };
    'cms/podcast-edit': { id?: string };
    'cms/podcasts': {};
    'cms/redirects': {};
    'cms/site-settings': {};
    'cms/support-ctas': {};
    'cms/tags': {};
    'contact-form-edit': { id?: string };
    'contact-form-submission-detail': { id: string };
    'contact-form-submissions': {};
    'contact-forms': {};
    'course-detail': { id: string };
    'course-edit': { id?: string };
    'course-interests': {};
    'course-tags': {};
    'course-term-attendance': { id: string };
    'course-term-edit': { id: string };
    'course-term-new': { courseId?: string };
    'course-terms': {};
    'courses': {};
    'dashboard': {};
    'discount-code-detail': { id: string };
    'discount-code-edit': { id?: string };
    'discount-codes': {};
    'email-template-detail': { group: string };
    'email-texts': {};
    'emails': {};
    'gd/call-edit': { id?: string; copyFrom?: string; issuer?: string };
    'gd/calls': {};
    'gd/checkout-probes': {};
    'gd/chrome': {};
    'gd/demo-user-detail': { id: string };
    'gd/demo-users': {};
    'gd/discount-code-edit': { id?: string };
    'gd/discount-codes': {};
    'gd/email-template-detail': { group: string };
    'gd/email-texts': {};
    'gd/emails': {};
    'gd': {};
    'gd/issuer-edit': { id?: string };
    'gd/issuers': {};
    'gd/order-edit': { id?: string };
    'gd/orders': {};
    'gd/page-edit': { id?: string };
    'gd/pages': {};
    'gd/plans': {};
    'gd/schvaleni': {};
    'gd/search': {};
    'gd/settings': {};
    'gd/subscriber-edit': { id?: string };
    'gd/subscribers': {};
    'gd/taxonomies': {};
    'gd/testimonials': {};
    'gd/user-edit': { id?: string };
    'gd/users': {};
    'members': {};
    'order-create': {};
    'order-detail': { id: string };
    'orders': {};
    'organization-detail': { id: string };
    'organizations': {};
    'search': {};
  }
}

// Page registry — page ID → route pattern
export const pageRegistry: Record<string, string> = {
  'index': '/',
  'login': '/login',
  'login/password-reset': '/login/password-reset',
  'login/reset-request-success': '/login/reset-request-success',
  'login/reset-request': '/login/reset-request',
  'api-keys': '/api-keys',
  'cms/article-edit': '/cms/article-edit',
  'cms/articles': '/cms/articles',
  'cms/banners': '/cms/banners',
  'cms/course-blocks-edit': '/cms/course-blocks-edit',
  'cms/footer': '/cms/footer',
  'cms/navigation': '/cms/navigation',
  'cms/page-edit': '/cms/page-edit',
  'cms/pages': '/cms/pages',
  'cms/people': '/cms/people',
  'cms/person-edit': '/cms/person-edit',
  'cms/podcast-edit': '/cms/podcast-edit',
  'cms/podcasts': '/cms/podcasts',
  'cms/redirects': '/cms/redirects',
  'cms/site-settings': '/cms/site-settings',
  'cms/support-ctas': '/cms/support-ctas',
  'cms/tags': '/cms/tags',
  'contact-form-edit': '/contact-form-edit',
  'contact-form-submission-detail': '/contact-form-submission-detail',
  'contact-form-submissions': '/contact-form-submissions',
  'contact-forms': '/contact-forms',
  'course-detail': '/course-detail',
  'course-edit': '/course-edit',
  'course-interests': '/course-interests',
  'course-tags': '/course-tags',
  'course-term-attendance': '/course-term-attendance',
  'course-term-edit': '/course-term-edit',
  'course-term-new': '/course-term-new',
  'course-terms': '/course-terms',
  'courses': '/courses',
  'dashboard': '/dashboard',
  'discount-code-detail': '/discount-code-detail',
  'discount-code-edit': '/discount-code-edit',
  'discount-codes': '/discount-codes',
  'email-template-detail': '/email-template-detail',
  'email-texts': '/email-texts',
  'emails': '/emails',
  'gd/call-edit': '/gd/call-edit',
  'gd/calls': '/gd/calls',
  'gd/checkout-probes': '/gd/checkout-probes',
  'gd/chrome': '/gd/chrome',
  'gd/demo-user-detail': '/gd/demo-user-detail',
  'gd/demo-users': '/gd/demo-users',
  'gd/discount-code-edit': '/gd/discount-code-edit',
  'gd/discount-codes': '/gd/discount-codes',
  'gd/email-template-detail': '/gd/email-template-detail',
  'gd/email-texts': '/gd/email-texts',
  'gd/emails': '/gd/emails',
  'gd': '/gd',
  'gd/issuer-edit': '/gd/issuer-edit',
  'gd/issuers': '/gd/issuers',
  'gd/order-edit': '/gd/order-edit',
  'gd/orders': '/gd/orders',
  'gd/page-edit': '/gd/page-edit',
  'gd/pages': '/gd/pages',
  'gd/plans': '/gd/plans',
  'gd/schvaleni': '/gd/schvaleni',
  'gd/search': '/gd/search',
  'gd/settings': '/gd/settings',
  'gd/subscriber-edit': '/gd/subscriber-edit',
  'gd/subscribers': '/gd/subscribers',
  'gd/taxonomies': '/gd/taxonomies',
  'gd/testimonials': '/gd/testimonials',
  'gd/user-edit': '/gd/user-edit',
  'gd/users': '/gd/users',
  'members': '/members',
  'order-create': '/order-create',
  'order-detail': '/order-detail',
  'orders': '/orders',
  'organization-detail': '/organization-detail',
  'organizations': '/organizations',
  'search': '/search',
};

const routeConfigs: RouteConfig[] = [
  {
    path: '/',
    component: Route0,
    isLayout: true,
    children: [
      {
        path: '/',
        component: lazy(Route1),
        preload: Route1,
        isIndex: true,
      },
      {
        path: '/login',
        component: Route2,
        isLayout: true,
        children: [
          {
            path: '/',
            component: lazy(Route3),
            preload: Route3,
            isIndex: true,
          },
          {
            path: '/password-reset',
            component: lazy(Route4),
            preload: Route4,
          },
          {
            path: '/reset-request-success',
            component: lazy(Route5),
            preload: Route5,
          },
          {
            path: '/reset-request',
            component: lazy(Route6),
            preload: Route6,
          },
        ],
      },
      {
        path: '/api-keys',
        component: lazy(Route7),
        preload: Route7,
      },
      {
        path: '/cms/article-edit',
        component: lazy(Route8),
        preload: Route8,
      },
      {
        path: '/cms/articles',
        component: lazy(Route9),
        preload: Route9,
      },
      {
        path: '/cms/banners',
        component: lazy(Route10),
        preload: Route10,
      },
      {
        path: '/cms/course-blocks-edit',
        component: lazy(Route11),
        preload: Route11,
      },
      {
        path: '/cms/footer',
        component: lazy(Route12),
        preload: Route12,
      },
      {
        path: '/cms/navigation',
        component: lazy(Route13),
        preload: Route13,
      },
      {
        path: '/cms/page-edit',
        component: lazy(Route14),
        preload: Route14,
      },
      {
        path: '/cms/pages',
        component: lazy(Route15),
        preload: Route15,
      },
      {
        path: '/cms/people',
        component: lazy(Route16),
        preload: Route16,
      },
      {
        path: '/cms/person-edit',
        component: lazy(Route17),
        preload: Route17,
      },
      {
        path: '/cms/podcast-edit',
        component: lazy(Route18),
        preload: Route18,
      },
      {
        path: '/cms/podcasts',
        component: lazy(Route19),
        preload: Route19,
      },
      {
        path: '/cms/redirects',
        component: lazy(Route20),
        preload: Route20,
      },
      {
        path: '/cms/site-settings',
        component: lazy(Route21),
        preload: Route21,
      },
      {
        path: '/cms/support-ctas',
        component: lazy(Route22),
        preload: Route22,
      },
      {
        path: '/cms/tags',
        component: lazy(Route23),
        preload: Route23,
      },
      {
        path: '/contact-form-edit',
        component: lazy(Route24),
        preload: Route24,
      },
      {
        path: '/contact-form-submission-detail',
        component: lazy(Route25),
        preload: Route25,
      },
      {
        path: '/contact-form-submissions',
        component: lazy(Route26),
        preload: Route26,
      },
      {
        path: '/contact-forms',
        component: lazy(Route27),
        preload: Route27,
      },
      {
        path: '/course-detail',
        component: lazy(Route28),
        preload: Route28,
      },
      {
        path: '/course-edit',
        component: lazy(Route29),
        preload: Route29,
      },
      {
        path: '/course-interests',
        component: lazy(Route30),
        preload: Route30,
      },
      {
        path: '/course-tags',
        component: lazy(Route31),
        preload: Route31,
      },
      {
        path: '/course-term-attendance',
        component: lazy(Route32),
        preload: Route32,
      },
      {
        path: '/course-term-edit',
        component: lazy(Route33),
        preload: Route33,
      },
      {
        path: '/course-term-new',
        component: lazy(Route34),
        preload: Route34,
      },
      {
        path: '/course-terms',
        component: lazy(Route35),
        preload: Route35,
      },
      {
        path: '/courses',
        component: lazy(Route36),
        preload: Route36,
      },
      {
        path: '/dashboard',
        component: lazy(Route37),
        preload: Route37,
      },
      {
        path: '/discount-code-detail',
        component: lazy(Route38),
        preload: Route38,
      },
      {
        path: '/discount-code-edit',
        component: lazy(Route39),
        preload: Route39,
      },
      {
        path: '/discount-codes',
        component: lazy(Route40),
        preload: Route40,
      },
      {
        path: '/email-template-detail',
        component: lazy(Route41),
        preload: Route41,
      },
      {
        path: '/email-texts',
        component: lazy(Route42),
        preload: Route42,
      },
      {
        path: '/emails',
        component: lazy(Route43),
        preload: Route43,
      },
      {
        path: '/gd/call-edit',
        component: lazy(Route44),
        preload: Route44,
      },
      {
        path: '/gd/calls',
        component: lazy(Route45),
        preload: Route45,
      },
      {
        path: '/gd/checkout-probes',
        component: lazy(Route46),
        preload: Route46,
      },
      {
        path: '/gd/chrome',
        component: lazy(Route47),
        preload: Route47,
      },
      {
        path: '/gd/demo-user-detail',
        component: lazy(Route48),
        preload: Route48,
      },
      {
        path: '/gd/demo-users',
        component: lazy(Route49),
        preload: Route49,
      },
      {
        path: '/gd/discount-code-edit',
        component: lazy(Route50),
        preload: Route50,
      },
      {
        path: '/gd/discount-codes',
        component: lazy(Route51),
        preload: Route51,
      },
      {
        path: '/gd/email-template-detail',
        component: lazy(Route52),
        preload: Route52,
      },
      {
        path: '/gd/email-texts',
        component: lazy(Route53),
        preload: Route53,
      },
      {
        path: '/gd/emails',
        component: lazy(Route54),
        preload: Route54,
      },
      {
        path: '/gd',
        component: lazy(Route55),
        preload: Route55,
      },
      {
        path: '/gd/issuer-edit',
        component: lazy(Route56),
        preload: Route56,
      },
      {
        path: '/gd/issuers',
        component: lazy(Route57),
        preload: Route57,
      },
      {
        path: '/gd/order-edit',
        component: lazy(Route58),
        preload: Route58,
      },
      {
        path: '/gd/orders',
        component: lazy(Route59),
        preload: Route59,
      },
      {
        path: '/gd/page-edit',
        component: lazy(Route60),
        preload: Route60,
      },
      {
        path: '/gd/pages',
        component: lazy(Route61),
        preload: Route61,
      },
      {
        path: '/gd/plans',
        component: lazy(Route62),
        preload: Route62,
      },
      {
        path: '/gd/schvaleni',
        component: lazy(Route63),
        preload: Route63,
      },
      {
        path: '/gd/search',
        component: lazy(Route64),
        preload: Route64,
      },
      {
        path: '/gd/settings',
        component: lazy(Route65),
        preload: Route65,
      },
      {
        path: '/gd/subscriber-edit',
        component: lazy(Route66),
        preload: Route66,
      },
      {
        path: '/gd/subscribers',
        component: lazy(Route67),
        preload: Route67,
      },
      {
        path: '/gd/taxonomies',
        component: lazy(Route68),
        preload: Route68,
      },
      {
        path: '/gd/testimonials',
        component: lazy(Route69),
        preload: Route69,
      },
      {
        path: '/gd/user-edit',
        component: lazy(Route70),
        preload: Route70,
      },
      {
        path: '/gd/users',
        component: lazy(Route71),
        preload: Route71,
      },
      {
        path: '/members',
        component: lazy(Route72),
        preload: Route72,
      },
      {
        path: '/order-create',
        component: lazy(Route73),
        preload: Route73,
      },
      {
        path: '/order-detail',
        component: lazy(Route74),
        preload: Route74,
      },
      {
        path: '/orders',
        component: lazy(Route75),
        preload: Route75,
      },
      {
        path: '/organization-detail',
        component: lazy(Route76),
        preload: Route76,
      },
      {
        path: '/organizations',
        component: lazy(Route77),
        preload: Route77,
      },
      {
        path: '/search',
        component: lazy(Route78),
        preload: Route78,
      },
    ],
  },
];

export const routes = buildRouteTree(routeConfigs);
